import styled from '@emotion/styled';
import { Link } from 'gatsby';
import React from 'react';
import Logo from '../assets/logo.svg';
import { mq } from './_shared/media';

const StyledHeader = styled.header`
  height: var(--header-height);
  flex-shrink: 0;
  background-color: transparent;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-left);
  z-index: 3;

  &::before {
    content: '';
    height: 5px;
    width: 100%;
    background-color: red;
  }
`;
const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 100%;
  padding: 0 calc((var(--space) / 2));
  position: relative;
  z-index: 500;
`;
const StyledHomeLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  padding-left: 0.5rem;

  ${mq.gt.lg} {
    padding-top: 2rem;
    padding-left: 0rem;
  }
`;
const StyledLogo = styled(Logo)`
  width: 245px;
  height: auto;
`;

const StyledNavLinkContainer = styled.nav`
  text-decoration: none;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  position: fixed;
  right: 6px;
  padding: 1rem;

  ${mq.lt.sm} {
    display: none;
  }
`;
const StyledNavLink = styled(Link)`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
  color: var(--darkbg-content-color) !important;
  background-color: var(--bright-purple-color);
  border: none;
  padding: 0.6rem 1rem;
  border-radius: var(--radius);
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;

  &:hover {
    background-color: var(--secondary-color) !important;
    color: #fff;
  }
`;

const Header = () => (
  <StyledHeader>
    <StyledContainer>
      <StyledHomeLink title="logo" to="/">
        <StyledLogo />
      </StyledHomeLink>
      <StyledNavLinkContainer>
        <StyledNavLink to="/join" activeClassName="active">
          Join our Beta
        </StyledNavLink>
        {/* <StyledNavLinkMobile to="/join" activeClassName="active">
          Join our Beta
        </StyledNavLinkMobile> */}
      </StyledNavLinkContainer>
    </StyledContainer>
  </StyledHeader>
);

export default Header;
